<div style="height: 100%" (click)="goInteractive()">
  <div class="map-wrapper" style="position: relative">
    <div *ngIf="tasks?.length > 1">
      <div style="position: absolute; top: 8px; right: 8px; z-index: 9">
        <div
          title="Single Task"
          [class.selected]="taskMode == false"
          class="task-or-route"
          (click)="toggleTaskMode($event, true)"
        >
          <div class="hide-on-mobile">Single Task</div>
          <div class="show-on-mobile"><img src="assets/images/svg/task_grey_icon.svg" /></div>
        </div>
        <div
          title="All Tasks"
          [class.selected]="taskMode == true"
          class="task-or-route"
          (click)="toggleTaskMode($event, false)"
        >
          <div class="hide-on-mobile">All tasks</div>
          <div class="show-on-mobile"><img src="assets/images/svg/route_grey_icon.svg" /></div>
        </div>
      </div>
    </div>

    <div *ngIf="interactiveMap" style="width: 100%; height: 100%">
      <tasks-map
        [tasks]="tasks"
        [selectedTaskId]="selectedTaskId"
        [mapOptions]="{ streetViewControl: false }"
        *ngIf="jobId && !routeId"
      ></tasks-map>
      <map-control-v2
        [routeId]="routeId"
        [displayTaskLegends]="true"
        [displayAdditionalLegendLabels]="false"
        [(selectedTaskId)]="selectedTaskId"
        *ngIf="routeId && !jobId"
      ></map-control-v2>
    </div>

    <div style="position: relative" *ngIf="!interactiveMap">
      <img *ngIf="mapImageUrl" [src]="mapImageUrl" alt="" class="map-image" />
    </div>
  </div>
</div>
